@let withBorder = isBestValue || isApprenticeship;

<div
  class="wrapper"
  [class]="withBorder ? activePlatformGroup + '-border' : ''"
  [class.product-best-value]="withBorder"
>
  <div class="title table-cell">&nbsp;</div>
  @for (platform of platformMapping; track platform.id) {
    <mkp-product-feature-cell class="table-cell" [feature]="platform" />
  }
  <div class="title benefit-title table-cell">&nbsp;</div>
  @for (benefit of benefitMapping; track benefit.id) {
    <mkp-product-feature-cell class="table-cell" [feature]="benefit" />
  }
</div>
